export function scrollToAnchor() {
  if (window.location.hash) {
      var anchor = document.querySelector(window.location.hash);
      if (anchor) {
          anchor.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
  }
}
